import styled from 'styled-components';


export const ChatContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const ChatBoxWrapper = styled.div`
  height: 100%;
  position: relative;
`;